import React from 'react';
import { Link } from 'react-router-dom';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';
import Description from '../../text/Description';
import { Utr, UtrLabel } from '../../text';
import { sportTypeIds } from '../../../utils/eventConstants';
import PickleBallRating from '../PlayerCard/SharedComponents/PickleBallRating';
import { gameTypes } from '../../../utils/constants';

const TeamPlayer = (props) => {
    const {
        player,
        index,
        showSeeProfileLink,
        userLoggedIn,
        showRatingNotLoggedIn,
        hideRatings,
        utrType,
        showDecimals,
        force = {},
        sportTypeId,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        nationality,
        firstName,
        lastName,
        gender,
        descriptionLong,
        descriptionShort,
        location,
        ratingStatusDoubles,
        playerProfileImages,
    } = player;

    const isPickleBallSportType = sportTypeId === sportTypeIds.PICKLEBALL;
    const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
    let description = '';
    if (descriptionLong) {
        description = [descriptionLong];
    } else {
        description = location && location.display ? [location.display] : [];
    }
    const descriptionItems = [
        ...(gender ? [gender.charAt(0)] : []),
        ...(description),
    ];
    let descriptionMobile = '';
    if (descriptionShort) {
        descriptionMobile = [descriptionShort];
    } else {
        descriptionMobile = location && location.display ? [location.display] : [];
    }
    const descriptionItemsMobile = [
        ...(gender ? [gender.charAt(0)] : []),
        ...(descriptionMobile),
    ];

    const renderLinkIf = (content, condition, Id) => {
        if (condition && Id) {
            const href = `/profiles/${Id}`;
            return (<Link to={href}>{content}</Link>);
        }
        return (content);
    };

    const showRatings = userLoggedIn || showRatingNotLoggedIn;

    if (force.cardView) {
        return renderLinkIf(
            <div className={`row ${index === 0 ? 'pb8' : ''} ${index === 1 ? 'pt8' : ''}`}>
                <div className="col-8">
                    <div className={`d-flex w-100`}>
                        <div className={`name-and-place show-ellipsis`}>
                            <div className="name h6 show-ellipsis" data-testid={dataTestId && `${dataTestId}.name`}>
                                {firstName} {lastName}
                            </div>
                            <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.place`}>
                                <Description desc={descriptionItemsMobile} />
                            </div>
                            {!hideRatings && (
                                <React.Fragment>
                                    {showRatings && !isPickleBallSportType && (
                                        <div>
                                            <span
                                                className={`text-dark value ${utrType === 'sanctioned' && ratingStatusDoubles !== 'Rated' ? 'text-lighter' : ''}`}
                                                title={utrType === 'sanctioned' ? ratingStatusDoubles : ''}
                                            >
                                                <Utr player={player} force={{ ratingType: 'doubles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} />
                                            </span>
                                            <span className="title">
                                                <UtrLabel player={player} force={{ ratingType: 'doubles', utrType, typeDots: true }} sportTypeId={sportTypeId} />
                                            </span>
                                        </div>
                                    )}
                                    {showRatings && isPickleBallSportType && (
                                        <PickleBallRating player={player} addSuffix ratingType={gameTypes.DOUBLES} data-testid={dataTestId && `${dataTestId}.pickleball`} />
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="avatar-container ml-auto">
                        <BackgroundImage
                            baseUrl={'/v1/player/'}
                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                            images={playerProfileImages}
                            imageType={'icon'}
                            parentStylesClass={'avatar'}
                        />
                        {nationality && (
                            <div className="flag-container">
                                <Img
                                    className="flag"
                                    src={nationalFlag}
                                    alt={nationality}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>,
            !showSeeProfileLink,
            id,
        );
    }

    return renderLinkIf(
        <div className={`d-flex ${index === 0 ? 'mb16' : ''} w-100`}>
            <div className="avatar-wrapper">
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={playerProfileImages}
                    imageType={'icon'}
                    parentStylesClass={'avatar d-inline-block'}
                />
                {nationalFlag && <Img className="flag" src={nationalFlag} alt={nationality} />}
            </div>
            <div className="name-and-place show-ellipsis">
                <div className="name show-ellipsis text-dark" data-testid={dataTestId && `${dataTestId}.name`}>{firstName} {lastName}</div>
                <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.place`}><Description desc={descriptionItems} /></div>
            </div>
        </div>,
        !showSeeProfileLink,
        id,
    );
};

TeamPlayer.defaultProps = {
    'data-testid': null,
};

export default TeamPlayer;
